angular.module("LeasePilot").directive("expandableCell", [
  function() {
    return {
      restrict: "A",
      scope: {
        content: "=",
      },
      template: `
        <div class="expandable-cell" ng-class="{'is-expanded': isExpanded}" ng-click="toggleExpand()">
          <pre class="cell-content" ng-class="{'truncated': !isExpanded}" ng-bind-html="content || '&nbsp;'"></pre>
          <button class="expand-toggle" aria-label="Toggle content expansion" ng-if="content">
            <md-tooltip md-direction="left">{{isExpanded ? 'Collapse' : 'Expand'}}</md-tooltip>
            <svg class="icon-chevron" ng-class="{'is-expanded': isExpanded}">
              <use xlink:href="#icon_down"></use>
            </svg>
          </button>
        </div>
      `,
      link: function(scope, element) {
        scope.isExpanded = false;

        scope.toggleExpand = function() {
          scope.isExpanded = !scope.isExpanded;
          if (!scope.isExpanded) {
            // Scroll only the cell content back to top when collapsing
            const cellContent = element[0].querySelector('.cell-content');
            if (cellContent) {
              cellContent.scrollTop = 0;
            }
          }
        };

        // Watch for content changes to ensure proper rendering
        scope.$watch('content', function() {
          // Use timeout to ensure DOM is updated
          setTimeout(() => {
            if (!scope.$root.$$phase) {
              scope.$apply();
            }
          }, 0);
        });
      }
    };
  }
]); 